/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import GlobalScope from '../../globalScope/GlobalScope';
import Subject from '../../rx/Subject';
import VersionManager from '../version/VersionManager';
import Parameters from '../../environment/Parameters';
import {defaultDiscoveryUri} from '../defaults';

export default class DiscoveryUri {
  private static readonly _discoveryUri: Subject<string> = new Subject<string>(defaultDiscoveryUri);

  static get uri(): Subject<string> {
    return DiscoveryUri._discoveryUri;
  }

  static buildDiscoveryUrl(uri: URL): string {
    const url = new GlobalScope.value.URL(uri.toString());
    const sdkVersion = VersionManager.sdkVersion;
    const intentions = Parameters.discoveryParameters.intentions;

    url.searchParams.set('version', sdkVersion);
    url.searchParams.set('intentions', intentions);
    url.searchParams.set('_', `${Date.now()}`);

    if (url.pathname === '/') {
      url.pathname = '/pcast/endPoints';
    }

    return url.toString();
  }

  private constructor() {
    throw new Error('DiscoveryUri is a static class that may not be instantiated');
  }
}